/** @file Export dialog key binding (global context); collected into bindings.gen.ts by pnpm gen. */
import type { Binding } from '@pose2d/shortcuts/types';

/** Mod+Shift+E opens the export dialog (Mod+E is taken by some browsers' address bar). */
export const bindings: Binding[] = [{ id: 'export.open', keys: 'Mod+Shift+KeyE', context: 'global' }];
